import React from 'react';

// Says, next to a disabled button, what is still missing ("Still needed: a subject, your e-mail"). Renders nothing once the
// list is empty, so the hint disappears exactly when the button comes alive.
const ReadyHint = ({ missing = [], className = '' }) => {
  if (!missing.length) return null;
  const shown = missing.slice(0, 3).join(', ');
  const more = missing.length > 3 ? ` and ${missing.length - 3} more` : '';
  return (
    <p className={`text-xs leading-snug text-oxblood ${className}`} aria-live="polite">
      Still needed: {shown}{more}
    </p>
  );
};

export default ReadyHint;
